(function () {
  'use strict';

  var root = document.querySelector('[data-tpl-sticky-cta]');
  if (!root) return;

  var targetSel = root.dataset.targetSelector || '[data-editorial-grid]';
  var revealVh = parseInt(root.dataset.revealAfterVh, 10) || 50;
  var link = root.querySelector('[data-tpl-sticky-cta-link]');

  var target = document.querySelector(targetSel);
  if (!target) {
    console.warn('[tpl-sticky-cta] target not found:', targetSel);
    return;
  }

  var gridInView = false;
  var scrolledPast = false;
  var hideTimeoutId = null;

  function updateVisibility() {
    var shouldShow = scrolledPast && !gridInView;
    if (shouldShow) {
      if (hideTimeoutId) {
        clearTimeout(hideTimeoutId);
        hideTimeoutId = null;
      }
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () {
        root.setAttribute('data-visible', 'true');
      });
    } else {
      root.setAttribute('data-visible', 'false');
      root.setAttribute('aria-hidden', 'true');
      hideTimeoutId = setTimeout(function () {
        if (root.getAttribute('data-visible') !== 'true') {
          root.hidden = true;
        }
        hideTimeoutId = null;
      }, 320);
    }
  }

  // IntersectionObserver — hide when grid is visible
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      gridInView = entry.isIntersecting;
      updateVisibility();
    });
  }, { threshold: 0.01 });
  observer.observe(target);

  // Scroll threshold — show after N vh scrolled
  function onScroll() {
    var threshold = window.innerHeight * (revealVh / 100);
    var newScrolledPast = window.scrollY > threshold;
    if (newScrolledPast !== scrolledPast) {
      scrolledPast = newScrolledPast;
      updateVisibility();
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Smooth-scroll to the IntersectionObserver target on click.
  // Always use `target` (the observed grid element) regardless of href —
  // guarantees the scroll destination matches what the observer watches.
  if (link) {
    link.addEventListener('click', function (e) {
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
})();
